/**
 * The Odino assistant launcher pill (Bot icon + label). Extracted so it can be
 * rendered in TWO places: normally in the Topbar's action cluster, AND — in
 * focus mode — as an escape-hatch OUTSIDE the inert/blurred chrome (the topbar
 * lock would otherwise trap it, and Odino is exactly the assistant you want
 * while editing a workflow/ETL/app). Gated on the `ai_plane` entitlement via
 * FeatureTip. `solid` gives it an opaque background so the focus-mode overlay
 * cleanly occludes the dimmed topbar behind it.
 */
import { Bot } from "lucide-react";

import { FeatureTip } from "@/components/billing/FeatureGate";
import { cn } from "@/lib/cn";

export function OdinoLauncher({
  open,
  onToggle,
  solid = false,
}: {
  open?: boolean;
  onToggle: () => void;
  solid?: boolean;
}) {
  return (
    <FeatureTip feature="ai_plane">
      <button
        type="button"
        onClick={onToggle}
        aria-label="Odino"
        aria-pressed={open}
        title="Odino — assistente di build"
        className={cn(
          "inline-flex h-9 items-center gap-1.5 rounded-md border px-2.5 text-sm font-medium transition",
          open
            ? "border-accent bg-accent/10 text-accent"
            : "border-border text-muted-foreground hover:border-muted-foreground hover:text-foreground",
          solid && !open && "bg-surface shadow-sm",
        )}
      >
        <Bot className="h-4 w-4" strokeWidth={1.5} />
        <span className="hidden sm:inline">Odino</span>
      </button>
    </FeatureTip>
  );
}
